import { node as basicRegistrationData } from "src/modules/ktx/forms/basic-registration-data";
import { node as committeeOpinion } from "src/modules/ktx/forms/committeeOpinion";
import { node as coordination } from "src/modules/ktx/forms/coordination";
import { node as transplantationScreening } from "src/modules/ktx/forms/transplantation-screening";
import { LeafNode, ParentNode } from "src/modules/shared/form-explorer";

export const forms: (ParentNode | LeafNode)[] = [
	basicRegistrationData,
	transplantationScreening,
	coordination,
	committeeOpinion
];
